import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import ReactGA from "react-ga4";
import './App.css'
import HomePage from './pages/home'
import NavBar from './components/navbar'
import GpxParser from './pages/gpx-parser'
import MovingSpeedTest from './pages/moving-network-speed-test'
import RouteTracker from "./components/RouteTracker";

ReactGA.initialize("G-P2TWPY6PDS");

function App() {
  return (
    <BrowserRouter>
      <RouteTracker />
      <NavBar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="gpx-parser" element={<GpxParser />} />
        <Route path="moving-network-speed-test" element={<MovingSpeedTest />} />
        <Route path="users" element={<GpxParser />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
